/** Public page frame (OutlierOS SharedReportView): sticky brand header with a CTA, content, disclaimer footer. */
import type { ReactNode } from 'react';
import { BRAND, hostsFor } from '@vw/core/src/brand';
import { BrandLogo } from '../../brand';
import { Toaster } from '@vw/ui';

export function PublicShell({ cta, children }: { cta: { label: string; href: string } | null; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b border-border bg-card/70 px-4 backdrop-blur sm:px-6">
        {/* The logo goes to the main website (anonymous visitors would hit sign-in on "/"). */}
        <a href={websiteOrigin()} className="flex items-center gap-2 text-sm font-bold"><BrandLogo size={28} />{BRAND.name}</a>
        <div className="flex-1" />
        {cta && <a href={cta.href} className="rounded-xl bg-primary px-3.5 py-2 text-xs font-semibold text-primary-foreground hover:bg-primary-hover">{cta.label}</a>}
      </header>
      <main className="mx-auto max-w-6xl space-y-8 px-4 py-8 sm:px-6">{children}</main>
      <footer className="mx-auto max-w-6xl px-6 pb-10 text-center text-xs text-muted-foreground">
        Metrics are public Instagram numbers captured when the creator was last scanned. Reels play through Instagram's own embed.
        {' '}{BRAND.name} is not affiliated with Instagram or Meta. · <a className="underline" href="/remove">Remove my profile</a> · <a className="underline" href={`mailto:${BRAND.supportEmail}`}>{BRAND.supportEmail}</a>
      </footer>
      <Toaster />
    </div>
  );
}

function websiteOrigin(): string {
  const h = location.hostname;
  if (h === 'localhost' || h === '127.0.0.1') return '/';
  return `https://${hostsFor(h.includes('-staging.') ? 'staging' : 'production').landing}`;
}

/** Sign-in link that returns to a path afterwards. */
export const signInHref = (returnTo: string) => `/signin?return_to=${encodeURIComponent(returnTo)}`;
